define('saveToFavorites',['routes', 'ajaxHelper', 'loadCss'], (routes, ajaxHelper, loadCss) => {
  // "use strict"; TODO Fix issues when using strict mode
  const partnerElement = document.getElementsByClassName('brand-logo');
  let partnerUrl = '';
  const modalCss = document.querySelector('#modalCss');
  const pendingItemsFromMail = document.cookie.match(new RegExp('TemporalFavoritesCookie_[0-9]=([^;]+)'));
  let mailFavorites = pendingItemsFromMail ? pendingItemsFromMail[1] : null;

  if (partnerElement && partnerElement.length > 0) {
    partnerUrl = partnerElement[0].href;
  }

  function isSignedIn() {
    const signInElement = document.querySelector('.nav__main .nhs_GlobalNavSignInUser');
    if (!signInElement) {
      return false;
    }

    return !signInElement.hasAttribute('data-sign-in');
  }

  const tryGetClosestButton = function (elem) {
    while (elem && elem.tagName !== 'BUTTON' && elem.tagName !== 'BODY') {
      elem = elem.parentElement;
    }

    return !elem || elem.tagName === 'BODY' ? undefined : elem;
  };

  const logSegmentEvent = function (segmentEvent, type, id) {
    const commonProperties = document.querySelector('#data-commonProperties_' + id);

    let eventForSegment = {
      event: segmentEvent,
      eventType: 'segmentEvent',
      home_id: type === 'HomePlan' ? id : null,
      spec_id: type === 'HomeSpec' ? id : null
    };

    if (type === 'Community') {
      eventForSegment.community_id = id;
    }

    if (commonProperties && commonProperties.dataset) {
      eventForSegment = Object.assign(eventForSegment, commonProperties.dataset);
      delete eventForSegment.button_action;
    }

    document.body.dispatchEvent &&
      document.body.dispatchEvent(new CustomEvent('trackOnDemandEvent', {
        detail: { data: eventForSegment }
      }));
  };

  const logTdvEvent = function (properties) {
    const eventForTdv = properties;
    eventForTdv.eventType = 'tdvEvent';
    document.body.dispatchEvent &&
      document.body.dispatchEvent(new CustomEvent('trackOnDemandEvent', {
        detail: { data: eventForTdv }
      }));
  };

  const removeFromCookie = function (items, id) {
    const itemIndex = items.map((item) => JSON.parse(item).id).indexOf(id);

    if (itemIndex >= 0) {
      items.splice(itemIndex, 1);
      const cookie = [
        'pendingSaveItem', '=', JSON.stringify(items), '; domain=.', window.location.host.toString(), '; path=/;'
      ].join('');
      document.cookie = cookie;
    }

    return itemIndex >= 0;
  };

  /**
  * @private
  * showLogInForSaveToFavorites: propmts a modal asking the user to log in in order to save more favorites.
  *
  * @param {HTML} element to grab the login url from
  */
  const showLogInForSaveToFavorites = function (element) {
    require(
      ['handlerAuth0'],
      (handlerAuth0) => {
        const options = {
          afterLogin() {
            performSave(
              element,
              element.dataset.url,
              element.dataset.category,
              element.dataset.type,
              element.dataset.id,
              element.dataset.url,
              element.dataset.name
            );
          }
        };
        handlerAuth0.init(options);
      }
    );
  };

  const temporalSaveToFavorites = function () {
    'use strict';

    const pendingItems = document.cookie.match(new RegExp('pendingSaveItem=([^;]+)'));
    const temporalSavedItems = pendingItems ? JSON.parse(pendingItems[1]) : [];
    const totalFavoritesSaved = document.querySelector('[data-total-favorites]');
    const isLoggedIn = isSignedIn();

    if (removeFromCookie(temporalSavedItems, this.dataset.id) && isLoggedIn) {
      updateStylesToUnsaved(this);
    }

    temporalSavedItems.push(JSON.stringify({
      element: this.id,
      category: this.dataset.category,
      type: this.dataset.type,
      id: this.dataset.id,
      url: this.dataset.url,
      name: this.dataset.name,
      dataset: this.dataset
    }));

    const cookie = [
      'pendingSaveItem', '=', JSON.stringify(temporalSavedItems), '; domain=.', window.location.host.toString(),
      '; path=/;'
    ].join('');
    document.cookie = cookie;

    showLogInForSaveToFavorites(this);

    document.body.dispatchEvent(new CustomEvent('customEventForSavedElements'));
  };

  const updateStylesToSaved = function (saveToFavoritesElement, id, parsedData) {
    const sharedKey = saveToFavoritesElement && saveToFavoritesElement.firstElementChild && saveToFavoritesElement.firstElementChild.children[1] ? saveToFavoritesElement.firstElementChild.children[1].getAttribute('data-shared') : null;
    const nextSharedKey = saveToFavoritesElement && saveToFavoritesElement.firstElementChild && saveToFavoritesElement.firstElementChild.children[0] ? saveToFavoritesElement.firstElementChild.children[0].getAttribute('data-shared') : null;

    if (saveToFavoritesElement.firstElementChild && saveToFavoritesElement.firstElementChild.children[0] && saveToFavoritesElement.firstElementChild.children[1]) {
      saveToFavoritesElement.firstElementChild.children[1].hide();
      saveToFavoritesElement.firstElementChild.children[0].show();
    }

    const saveToFavsElements = document.querySelectorAll('[data-id="' + id + '"]');
    for (let i = 0; i < saveToFavsElements.length; i += 1) {
      if (saveToFavsElements[i].firstElementChild &&
        saveToFavsElements[i].firstElementChild.children[0] &&
        saveToFavsElements[i].firstElementChild.children[1]) {
        saveToFavsElements[i].firstElementChild.children[1].hide();
        saveToFavsElements[i].firstElementChild.children[0].show();
      }
      if (saveToFavsElements[i].firstElementChild && saveToFavsElements[i].firstElementChild.children[0]) {
        saveToFavsElements[i].firstElementChild.children[0].setAttribute('data-favoriteid', parsedData.Id);
        saveToFavsElements[i].setAttribute('data-favoriteid', parsedData.Id);
      }
    }

    if (sharedKey) {
      const twinElement = document.querySelectorAll("path[data-shared='" + sharedKey + "']");

      if (twinElement) {
        for (let elementIndex = 0; elementIndex < twinElement.length; elementIndex += 1) {
          const element = twinElement[elementIndex];

          if (element) {
            element.hide();
          }
        }
      }
    }

    if (nextSharedKey) {
      const nextTwinElement = document.querySelectorAll("path[data-shared='" + nextSharedKey + "']");

      if (nextTwinElement) {
        for (let nextElementIndex = 0; nextElementIndex < nextTwinElement.length; nextElementIndex += 1) {
          const nextElement = nextTwinElement[nextElementIndex];

          if (nextElement) {
            nextElement.setAttribute('data-favoriteid', parsedData.Id);
            nextElement.show();
          }
        }
      }
    }

    // 55+ Result title fav
    const ffpResult = document.querySelector(".nhs_CommResItem[data-id^='" + id + "']");
    if (ffpResult) {
      const title = ffpResult.querySelector("h3[itemprop='name']");
      if (!title.querySelector('span.ir.nhs_Saved')) {
        const favIcon = document.createRange().createContextualFragment("<span class='ir nhs_Saved'>Saved</span>");
        title.insertBefore(favIcon, title.firstChild);
        const parent = self.currentItem.parentElement;
        if (parent) {
          parent.querySelector('.nhs_Saved').style.display = '';
          self.currentItem.style.display = 'none';
        }
      }
    }
  };

  var updateStylesToUnsaved = function (saveToFavoritesElement) {
    const sharedKey = saveToFavoritesElement && saveToFavoritesElement.firstElementChild ? saveToFavoritesElement.firstElementChild.children[1].getAttribute('data-shared') : null;
    const nextSharedKey = saveToFavoritesElement && saveToFavoritesElement.firstElementChild ? saveToFavoritesElement.firstElementChild.children[0].getAttribute('data-shared') : null;

    if (saveToFavoritesElement.firstElementChild && saveToFavoritesElement.firstElementChild.children[0] && saveToFavoritesElement.firstElementChild.children[1]) {
      saveToFavoritesElement.firstElementChild.children[0].hide();
      saveToFavoritesElement.firstElementChild.children[1].show();
    }

    const saveToFavsElements = document.querySelectorAll('[data-save-element]');
    for (let i = 0; i < saveToFavsElements.length; i += 1) {
      const savedIconElement = saveToFavsElements[i].firstElementChild ? saveToFavsElements[i].firstElementChild.children[0] : undefined;
      const unsavedIconElement = saveToFavsElements[i].firstElementChild ? saveToFavsElements[i].firstElementChild.children[1] : undefined;
      if (savedIconElement &&
        unsavedIconElement &&
        savedIconElement.dataset.id == saveToFavoritesElement.dataset.id) {
        savedIconElement.hide();
        unsavedIconElement.show();
        saveToFavsElements[i].removeAttribute('data-favid');
      }
    }

    saveToFavoritesElement.removeAttribute('data-favid');
    document.body.dispatchEvent(new CustomEvent('customEventForUnsavedElements'));

    if (sharedKey) {
      const twinElement = document.querySelectorAll("path[data-shared='" + sharedKey + "']");

      if (twinElement) {
        for (let elementIndex = 0; elementIndex < twinElement.length; elementIndex += 1) {
          const element = twinElement[elementIndex];

          if (element) {
            element.show();
            element.removeAttribute('data-favid');
          }
        }
      }
    }

    if (nextSharedKey) {
      const nextTwinElement = document.querySelectorAll("path[data-shared='" + nextSharedKey + "']");

      if (nextTwinElement) {
        for (let nextElementIndex = 0; nextElementIndex < nextTwinElement.length; nextElementIndex += 1) {
          const nextElement = nextTwinElement[nextElementIndex];

          if (nextElement) {
            nextElement.hide();
          }
        }
      }
    }

    // 55+ Result title fav
    const id = saveToFavoritesElement.id.match(/\d+$/gmi);
    const ffpResult = document.querySelector(".nhs_CommResItem[data-id^='" + id + "']");
    if (ffpResult) {
      const title = ffpResult.querySelector("h3[itemprop='name']");
      const favIcon = title.querySelector('.ir.nhs_Saved');
      title.removeChild(favIcon);
      const parent = self.currentItem.parentElement;
      if (parent) {
        self.currentItem.style.display = 'none';
        parent.querySelector('.nhs_Save').style.display = '';
      }
    }
  };

  var performSave = function (saveToFavoritesElement, link, category, type, id, url, name) {
    const self = this;
    self.currentItem = saveToFavoritesElement;
    ajaxHelper.postRequest(partnerUrl + routes.saveToFavoritesMobile, {
      data: {
        Type: type,
        Id: id,
        FavoriteUrl: url,
        Title: name
      },
      abort: false,
      success(data) {
        const isHtmlElement = self.currentItem instanceof HTMLElement;
        const parsedData = JSON.parse(data);
        if (!parsedData.Saved) { return; }

        if (isHtmlElement === true) {
          self.currentItem.setAttribute('data-favoriteid', parsedData.Id);
        }

        logSegmentEvent((type === 'HomePlan' || type === 'HomeSpec') ? 'Home Saved' : 'Community Saved', type, id);
        document.body.dispatchEvent(new CustomEvent('customEventForSavedElements'));

        // element is the dom element that contain data attributes to get data in persona.js
        let element = isHtmlElement ? saveToFavoritesElement.querySelector('path:not([data-remove-local-storage="True"])') : null;
        if (!element) {
          element = {
            dataset: saveToFavoritesElement.dataset
          };
        }
        document.body.dispatchEvent &&
          document.body.dispatchEvent(new CustomEvent('trackIdentifySaveItems', {
            detail: { data: element }
          }));

        if (isHtmlElement === true) {
          updateStylesToSaved(saveToFavoritesElement, id, parsedData);
        }
      },
      requestHeaders: [{
        name: 'Content-Type',
        value: 'application/json'
      }]
    });
  };

  const performDelete = function (saveToFavoritesElement, elementId) {
    const self = this;
    self.currentItem = saveToFavoritesElement;

    const dataToSend = {
      id: parseInt(elementId) || parseInt(self.currentItem.getAttribute('data-favid'))
    };

    ajaxHelper.postRequest(partnerUrl + routes.deleteFromFavoritesMobile, {
      data: dataToSend,
      abort: true,
      success(data) {
        const parsedData = JSON.parse(data);
        if (!parsedData.Saved) { return; }

        const element = saveToFavoritesElement.querySelector('path:not([style*="display:none"]):not([style*="display: none"])');
        document.body.dispatchEvent &&
          document.body.dispatchEvent(new CustomEvent('trackIdentifySaveItems', {
            detail: { data: element }
          }));
        updateStylesToUnsaved(saveToFavoritesElement);
      },
      requestHeaders: [{
        name: 'Content-Type',
        value: 'application/json'
      }]
    });
  };

  const deleteFromFavorites = function (element) {
    const is_SignedIn = isSignedIn();
    delete element.dataset.event;
    if (is_SignedIn) {
      if (element.firstElementChild &&
        element.firstElementChild.children[0] &&
        element.firstElementChild.children[0].dataset.favoriteid) {
        performDelete(element, element.firstElementChild.children[0].dataset.favoriteid);
      } else if (element) {
        const id = element.dataset.favoriteid ||
          Number(element.dataset.favid) ||
          Number(element.dataset.element.replace('nhs_SaveItem', ''));
        performDelete(element, id);
      }
    } else {
      temporalSaveToFavorites.apply(element);
    }
  };

  const saveToFavorites = function (element) {
    const is_SignedIn = isSignedIn();
    element.dataset.event = 'true';
    const type = element.dataset.type;
    logSegmentEvent((type === 'HomePlan' || type === 'HomeSpec') ? 'Home Favorited' : 'Community Favorited', type, element.dataset.id);
    if (is_SignedIn) {
      performSave(
        element,
        element.dataset.url,
        element.dataset.category,
        element.dataset.type,
        element.dataset.id,
        element.dataset.url,
        element.dataset.name
      );
    } else {
      temporalSaveToFavorites.apply(element);
    }

    const tdvProperties = {
      community: element.dataset.id,
      market: NewHomeSource.Modules.tagManager.getFromDataLayer('marketId'),
      label: (type === 'HomePlan' || type === 'HomeSpec') ? 'SAVETOFAV_HR' : 'SAVETOFAV_CR'
    };
    logTdvEvent(tdvProperties);
  };

  const saveToFavoritesHandler = function (event) {
    let elm = event.target || event.srcElement;
    if (elm.tagName !== 'BUTTON') {
      elm = tryGetClosestButton(elm);
    }

    if (!elm) {
      return;
    }

    if (elm.classList.contains('nhs_SavedListing') || elm.dataset.favoritesButton === 'true') {
      const modalCss = document.querySelector('#modalCss');
      loadCss(modalCss.value);
      if (elm.firstElementChild.children[1] && elm.firstElementChild.children[1].style.display == 'block' || elm.classList.contains('nhs_Save')) {
        saveToFavorites(elm);
      } else if (elm.firstElementChild.children[1] && elm.firstElementChild.children[1].style.display == 'none' || elm.classList.contains('nhs_Saved')) {
        deleteFromFavorites(elm);
      }
    } else if (elm.classList.contains('nhs_Save')) {
      saveToFavorites(elm);
    } else if (elm.classList.contains('nhs_SavedListing') || elm.classList.contains('nhs_Saved')) {
      deleteFromFavorites(elm);
    }
  };

  const updateSavesWhenLoggedIn = function () {
    let saveFavoritesList = document.getElementsByClassName('nhs_SavedListing');
    const saveFavoritesIds = [];
    let isFfplus = false;

    if (saveFavoritesList.length === 0) { // 55+ SRP does not have this kind of elements, so let's try with 55+ results
      const _saveFavoritesList = Array.from(document.querySelectorAll('.nhs_ResItem.nhs_CommResItem.clearfix.nhs_Row[data-id]'));
      if (_saveFavoritesList.length > 0) {
        isFfplus = true;
        saveFavoritesList = _saveFavoritesList;
      }
    }
    let counter;
    if (!isFfplus) {
      for (counter = 0; counter < saveFavoritesList.length; counter++) {
        saveFavoritesIds.push(saveFavoritesList[counter].dataset.id);
      }
    } else {
      for (counter = 0; counter < saveFavoritesList.length; counter++) {
        saveFavoritesIds.push(saveFavoritesList[counter].dataset.id.split('-')[0]);
      }
    }

    const pendingItems = document.cookie.match(new RegExp('pendingSaveItem=([^;]+)'));
    const cookieFavorites = pendingItems ? JSON.parse(pendingItems[1]) : [];

    if (cookieFavorites) {
      for (let index = cookieFavorites.length - 1; index >= 0; index -= 1) {
        const favoriteString = cookieFavorites[index];
        const favoriteObject = JSON.parse(favoriteString);
        const saveElements = document.querySelectorAll('#' + favoriteObject.element);

        for (const element of saveElements) {
          updateStylesToSaved(element.dataset.category, favoriteObject.id, 0, element);
        }

        removeFromCookie(cookieFavorites, favoriteObject.id);
        let elementToLog = document.querySelector(`[data-id="${favoriteObject.id}"]`) || null;
        if (!elementToLog) {
          elementToLog = {
            dataset: favoriteObject.dataset
          };
        }

        performSave(
          elementToLog,
          favoriteObject.url,
          favoriteObject.category,
          favoriteObject.type,
          favoriteObject.id,
          favoriteObject.url,
          favoriteObject.name
        );
      }
    }

    ajaxHelper.postRequest(partnerUrl + routes.checkSaveToFavoritesMobile, {
      data: {
        listingIds: saveFavoritesIds
      },
      success(data) {
        const parsedData = JSON.parse(data);

        if (!(parsedData !== null && parsedData.ListOfIds.length > 0)) { return; }
        let counter;
        if (!isFfplus) {
          const currentElement = document.querySelectorAll('.nhs_SavedListing');
          for (counter = 0; counter < parsedData.ListOfIds.length; counter++) {
            let counterElement = 0;
            while (counterElement < currentElement.length) {
              if (currentElement.length > 0 && currentElement[counterElement].firstElementChild) {
                if (currentElement[counterElement].firstElementChild && currentElement[counterElement].firstElementChild.children[0] && parseInt(currentElement[counterElement].firstElementChild.children[0].dataset.id) == parsedData.ListOfIds[counter]) {
                  currentElement[counterElement].firstElementChild.children[0].show();
                  currentElement[counterElement].firstElementChild.children[1].hide();
                  currentElement[counterElement].setAttribute('data-favid', parsedData.ListOfSaved[counter]);
                }
              }
              counterElement++;
            }
          }
        } else {
          for (counter = 0; counter < parsedData.ListOfIds.length; counter++) {
            const _id = parsedData.ListOfIds[counter];
            const ffpResult = document.querySelector(".nhs_CommResItem[data-id^='" + _id + "']");
            if (ffpResult) {
              const title = ffpResult.querySelector("h3[itemprop='name']");
              if (!title.querySelector('span.ir.nhs_Saved')) {
                const favIcon = document.createRange().createContextualFragment("<span class='ir nhs_Saved'>Saved</span>");
                title.insertBefore(favIcon, title.firstChild);
              }
            }
          }
        }
      },
      requestHeaders: [{
        name: 'Content-Type',
        value: 'application/json'
      }]
    });
  };

  const updateSavesWhenLoggedOut = function () {
    let saveFavoritesList = document.getElementsByClassName('nhs_SavedListing ');

    let isFfplus = false;
    if (saveFavoritesList.length === 0) { // 55+ SRP does not have this kind of elements, so let's try with 55+ results
      const _saveFavoritesList = Array.from(document.querySelectorAll('.nhs_ResItem.nhs_CommResItem.clearfix.nhs_Row[data-id]'));
      if (_saveFavoritesList.length > 0) {
        isFfplus = true;
        saveFavoritesList = _saveFavoritesList;
      }
    }
    let counter;
    if (!isFfplus) {
      for (counter = 0; counter < saveFavoritesList.length; counter++) {
        const currentElement = saveFavoritesList[counter];
        if (currentElement.firstElementChild) {
          currentElement.firstElementChild.children[0].hide();
          currentElement.firstElementChild.children[1].show();
        }
        currentElement.removeAttribute('data-favid');
      }
    } else {
      for (counter = 0; counter < saveFavoritesList.length; counter++) {
        const ffpResult = saveFavoritesList[counter];
        if (ffpResult) {
          const title = ffpResult.querySelector("h3[itemprop='name']");
          const favIcon = title.querySelector('.ir.nhs_Saved');
          if (favIcon) {
            title.removeChild(favIcon);
          }
        }
      }
    }
  };

  /**
   * Used to determine if an user has pending items
   * @returns a boolean value
   */
  const userHasPendingItems = function () {
    const pendingItems = document.cookie.match(new RegExp('pendingSaveItem=([^;]+)'));
    return !!pendingItems;
  };

  const init = function () {
    document.body.addEventListener('click', saveToFavoritesHandler);
    document.addEventListener('updateSavesWhenLoggedIn', updateSavesWhenLoggedIn);
    document.addEventListener('updateSavesWhenLoggedOut', updateSavesWhenLoggedOut);

    const isUserSignedIn = isSignedIn();
    const pendingItems = userHasPendingItems();

    if (isUserSignedIn && pendingItems) {
      updateSavesWhenLoggedIn();
    }
  };

  /**
  * @private
  * handleEmailFavorites: considers favorites comming from email and concats them to the cookie that handles favorites from navigation.
  */
  const handleEmailFavorites = function () {
    const pendingItems = document.cookie.match(new RegExp('pendingSaveItem=([^;]+)'));
    const cookieFavorites = pendingItems ? JSON.parse(pendingItems[1]) : [];

    if (mailFavorites && cookieFavorites.toString().indexOf(JSON.parse(mailFavorites).id) === -1) {
      const topSaveElement = document.querySelector('[data-save-element]');

      if (cookieFavorites.length > 0) {
        loadCss(modalCss.value);
        showLogInForSaveToFavorites(topSaveElement);
        return;
      }

      showTemporalSaveToolTip(JSON.parse(mailFavorites).id, cookieFavorites, topSaveElement);
      cookieFavorites.push(mailFavorites);

      const cookie = [
        'pendingSaveItem', '=', JSON.stringify(cookieFavorites), '; domain=.', window.location.host.toString(),
        '; path=/;'
      ].join('');
      document.cookie = cookie;

      mailFavorites = null;
    }
  };

  handleEmailFavorites();

  return {
    init
  };
});

